import React from 'react';

import logo from 'assets/img/something-went-wrong.svg';

type ErrorBoundaryProps = {
  children?: React.ReactNode;
  error?: Error;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: props.error };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    const error = this.props.error || this.state.error;
    if (this.state.hasError || error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 40,
            textAlign: 'center',
          }}
        >
          <img src={logo} alt='Something went wrong' style={{ width: '30%', marginBottom: 32 }} />
          <h1 style={{ fontSize: 32, marginBottom: 16 }}>Aaaah! Something went wrong</h1>
          <p style={{ fontSize: 18, marginBottom: 8 }}>Brace yourself till we get the error fixed.</p>
          <p style={{ fontSize: 16, color: '#666', marginBottom: 24 }}>
            You may also refresh the page or try again later
          </p>
        </div>
      );
    }
    return this.props.children || null;
  }
}

export default ErrorBoundary;
